import hexRgb from "hex-rgb"
import { COLOUR_NAME_TO_COLOUR_HEX } from "../../../../../../../helpers/Colours";

export const GET_ANIMOVERLAY_SETTINGS = (customisationData, campaignData) => {
    const settingsObj = {};

    const obj_1 = {};
    obj_1.displayType = customisationData.visual.overlaySettings.displayType[0].selected;
    obj_1.titleScale = Number(customisationData.visual.campaignLogo.campaignLogo[0].scale);
    obj_1.logoScale = Number(customisationData.visual.campaignLogo.clientLogo[0].scale);
    obj_1.backgroundType = customisationData.visual.overlaySettings.backgroundType[0].selected;
    obj_1.tileBg = customisationData.visual.overlaySettings.bgPattern[0].tileBackground;
    obj_1.colour = COLOUR_NAME_TO_COLOUR_HEX(customisationData.visual.overlaySettings.colour[0].selected, campaignData);
    obj_1.colourOpacity = Number(customisationData.visual.overlaySettings.colour[0].opacity);
    obj_1.gradientFrom = COLOUR_NAME_TO_COLOUR_HEX(customisationData.visual.overlaySettings.gradient[0].from, campaignData);
    obj_1.gradientTo = COLOUR_NAME_TO_COLOUR_HEX(customisationData.visual.overlaySettings.gradient[0].to, campaignData);
    obj_1.gradientOpacity = Number(customisationData.visual.overlaySettings.gradient[0].opacity);
    obj_1.gradientDirection = customisationData.visual.overlaySettings.gradient[0].direction;
    settingsObj.displayOptions = obj_1;

    const obj_2 = {};
    obj_2.animateInType = customisationData.animation.clientLogoAnimationOptions.animateInSettings[0].type;
    obj_2.animateInTime = Number(customisationData.animation.clientLogoAnimationOptions.animateInSettings[0].time);
    obj_2.animateInDelay = Number(customisationData.animation.clientLogoAnimationOptions.animateInSettings[0].delay);
    obj_2.animateInEase = customisationData.animation.clientLogoAnimationOptions.animateInSettings[0].ease;

    obj_2.animateOutType = customisationData.animation.clientLogoAnimationOptions.animateOutSettings[0].type;
    obj_2.animateOutTime = Number(customisationData.animation.clientLogoAnimationOptions.animateOutSettings[0].time);
    obj_2.animateOutDelay = Number(customisationData.animation.clientLogoAnimationOptions.animateOutSettings[0].delay);
    obj_2.animateOutEase = customisationData.animation.clientLogoAnimationOptions.animateOutSettings[0].ease;
    settingsObj.logoAnimationOptions = obj_2;

    const obj_3 = {};
    obj_3.animateInType = customisationData.animation.campaignLogoAnimationOptions.animateInSettings[0].type;
    obj_3.animateInTime = Number(customisationData.animation.campaignLogoAnimationOptions.animateInSettings[0].time);
    obj_3.animateInDelay = Number(customisationData.animation.campaignLogoAnimationOptions.animateInSettings[0].delay);
    obj_3.animateInEase = customisationData.animation.campaignLogoAnimationOptions.animateInSettings[0].ease;

    obj_3.animateOutType = customisationData.animation.campaignLogoAnimationOptions.animateOutSettings[0].type;
    obj_3.animateOutTime = Number(customisationData.animation.campaignLogoAnimationOptions.animateOutSettings[0].time);
    obj_3.animateOutDelay = Number(customisationData.animation.campaignLogoAnimationOptions.animateOutSettings[0].delay);
    obj_3.animateOutEase = customisationData.animation.campaignLogoAnimationOptions.animateOutSettings[0].ease;
    settingsObj.titleAnimationOptions = obj_3;

    const obj_4 = {};
    obj_4.playBgAudio = customisationData.audio.toggleTriggerSFX.toggleSFX[0].playBgAudio;
    obj_4.playStartAudio = customisationData.audio.toggleTriggerSFX.toggleSFX[0].playStartAudio;
    obj_4.playEndAudio = customisationData.audio.toggleTriggerSFX.toggleSFX[0].playEndAudio;
    obj_4.audioSettings = customisationData.audio.triggerSFX;
    settingsObj.audio = obj_4;

    console.log('Build anim overlay settings object: ', settingsObj);
    return settingsObj;
}

export const TEMPLATE_TYPES = {
    fullScreen: 'full-screen',
    bottomThird: 'bottom-1-3',
    bottomSixth: 'bottom-1-6',
    leftSide: 'left-side',
    rightSide: 'right-side',
    topLeft: 'top-left',
    topMiddle: 'top-middle',
    topRight: 'top-right',
}

export const BG_TYPES = {
    none: 'none',
    solidColour: 'solid-colour',
    gradient: 'gradient',
    image: 'image',
}

export const GRADIENT_DIRECTIONS = {
    horizontal: 'horizontal',
    vertical: 'vertical',
}

export const ANIMATION_OPTIONS = {
    fade: 'fade',
    pop: 'pop',
    slideInLeft: 'slide-left',
    slideInRight: 'slide-right',
    slideInTop: 'slide-top',
    slideInBottom: 'slide-bottom',
}

export const EASE_OPTIONS = {
    circ: 'circ',
    back: 'back',
    bounce: 'bounce',
    none: 'none',
}

export const getBgStyle = (displayOptions, bgImageData, previewScale = 1) => {
    const styleObj = { position: 'absolute', transform: `scale(${previewScale})` };

    switch (displayOptions.displayType) {

        case TEMPLATE_TYPES.fullScreen:
            styleObj.width = 1920; // * previewScale;
            styleObj.height = 1080; // * previewScale;
            styleObj.left = 0;
            styleObj.top = 0;
            styleObj.transformOrigin = 'top left';
            break;

        case TEMPLATE_TYPES.bottomThird:
            styleObj.width = 1920; // * previewScale;
            styleObj.height = (displayOptions.backgroundType === BG_TYPES.solidColour || displayOptions.gradientDirection === GRADIENT_DIRECTIONS.vertical) ? 360 : 640;
            styleObj.left = 0;
            styleObj.bottom = 0;
            styleObj.transformOrigin = 'bottom left';
            break;

        case TEMPLATE_TYPES.bottomSixth:
            styleObj.width = 1920; // * previewScale;
            styleObj.height = (displayOptions.backgroundType === BG_TYPES.solidColour || displayOptions.gradientDirection === GRADIENT_DIRECTIONS.vertical) ? 180 : 400;
            styleObj.left = 0;
            styleObj.bottom = 0;
            styleObj.transformOrigin = 'bottom left';
            break;

        case TEMPLATE_TYPES.leftSide:
            styleObj.width = (displayOptions.backgroundType === BG_TYPES.solidColour || displayOptions.gradientDirection === GRADIENT_DIRECTIONS.horizontal) ? 480 : 1000;
            styleObj.height = 1080;
            styleObj.left = 0;
            styleObj.top = 0;
            styleObj.transformOrigin = 'top left';
            break;

        case TEMPLATE_TYPES.rightSide:
            styleObj.width = (displayOptions.backgroundType === BG_TYPES.solidColour || displayOptions.gradientDirection === GRADIENT_DIRECTIONS.horizontal) ? 480 : 1000;
            styleObj.height = 1080;
            styleObj.right = 0;
            styleObj.top = 0;
            styleObj.transformOrigin = 'top right';
            break;

        case TEMPLATE_TYPES.topLeft:
            styleObj.width = 1400; // * previewScale;
            styleObj.height = displayOptions.backgroundType === BG_TYPES.solidColour ? 360 : 480;
            styleObj.left = 0;
            styleObj.top = 0;
            styleObj.transformOrigin = 'top left';
            break;

        case TEMPLATE_TYPES.topMiddle:
            styleObj.width = 1920; // * previewScale;
            styleObj.height = displayOptions.backgroundType === BG_TYPES.solidColour ? 360 : 480;
            styleObj.left = 0;
            styleObj.top = 0;
            styleObj.transformOrigin = 'top left';
            break;

        case TEMPLATE_TYPES.topRight:
            styleObj.width = 1400; // * previewScale;
            styleObj.height = displayOptions.backgroundType === BG_TYPES.solidColour ? 360 : 480;
            styleObj.right = 0;
            styleObj.top = 0;
            styleObj.transformOrigin = 'top right';
            break;

        default:
            break;

    }

    switch (displayOptions.backgroundType) {

        case BG_TYPES.solidColour:
            styleObj.background = displayOptions.colour;
            styleObj.opacity = displayOptions.colourOpacity / 100;
            break;

        case BG_TYPES.gradient:
            styleObj.background = getGradient(displayOptions);
            styleObj.opacity = displayOptions.gradientOpacity / 100;
            break;

        case BG_TYPES.image:
            styleObj.backgroundImage = bgImageData ? `url(${bgImageData.srcUrl})` : null;
            styleObj.backgroundRepeat = displayOptions.tileBg ? 'repeat' : 'no-repeat';
            styleObj.backgroundPosition = 'center';
            // styleObj.backgroundSize = displayOptions.tileBg ? null : 'cover';
            styleObj.opacity = 1;
            break;
        default:
            break;

    }

    return styleObj;
}

const getGradient = (displayOptions) => {
    const fromRgb = hexRgb(displayOptions.gradientFrom);
    const toRgb = hexRgb(displayOptions.gradientTo);

    switch (displayOptions.displayType) {
        case TEMPLATE_TYPES.fullScreen:
            if (displayOptions.gradientDirection === GRADIENT_DIRECTIONS.horizontal) {
                return 'linear-gradient(to right, ' + displayOptions.gradientFrom + ', ' + displayOptions.gradientTo + ')';
            } else {
                return 'linear-gradient(to bottom, ' + displayOptions.gradientFrom + ', ' + displayOptions.gradientTo + ')';
            }

        case TEMPLATE_TYPES.topLeft:
            return 'radial-gradient(ellipse at 0% 0%, ' + displayOptions.gradientFrom + ', ' + displayOptions.gradientTo + ' 30%, rgba(' + toRgb.red + ', ' + toRgb.green + ', ' + toRgb.blue + ', 0) 50% )';

        case TEMPLATE_TYPES.topRight:
            return 'radial-gradient(ellipse at 100% 0%, ' + displayOptions.gradientFrom + ', ' + displayOptions.gradientTo + ' 30%, rgba(' + toRgb.red + ', ' + toRgb.green + ', ' + toRgb.blue + ', 0) 50% )';

        case TEMPLATE_TYPES.bottomSixth:
        case TEMPLATE_TYPES.bottomThird:
            if (displayOptions.gradientDirection === GRADIENT_DIRECTIONS.vertical) {
                return 'linear-gradient(to top, ' + displayOptions.gradientFrom + ', ' + displayOptions.gradientTo + ' 70%, rgba(' + toRgb.red + ', ' + toRgb.green + ', ' + toRgb.blue + ', 0) 100% )';
            } else {
                return `
                    radial-gradient(
                        ellipse at 10% 100%,
                        rgba(${fromRgb.red}, ${fromRgb.green}, ${fromRgb.blue}, 0.4),
                        rgba(${fromRgb.red}, ${fromRgb.green}, ${fromRgb.blue}, 0)
                        10%
                    ),
                    radial-gradient(
                        ellipse at 20% 100%,
                        rgba(${fromRgb.red}, ${fromRgb.green}, ${fromRgb.blue}, 0.7),
                        rgba(${fromRgb.red}, ${fromRgb.green}, ${fromRgb.blue}, 0)
                        30%
                    ),
                    radial-gradient(
                        ellipse at 40% 100%,
                        rgba(${fromRgb.red}, ${fromRgb.green}, ${fromRgb.blue}, 1),
                        rgba(${fromRgb.red}, ${fromRgb.green}, ${fromRgb.blue}, 0)
                        40%
                    ),
                    radial-gradient(
                        ellipse at 60% 100%,
                        rgba(${toRgb.red}, ${toRgb.green}, ${toRgb.blue}, 1),
                        rgba(${toRgb.red}, ${toRgb.green}, ${toRgb.blue}, 0)
                        40%
                    ),
                    radial-gradient(
                        ellipse at 80% 100%,
                        rgba(${toRgb.red}, ${toRgb.green}, ${toRgb.blue}, 0.7),
                        rgba(${toRgb.red}, ${toRgb.green}, ${toRgb.blue}, 0)
                        30%
                    ),
                    radial-gradient(
                        ellipse at 90% 100%,
                        rgba(${toRgb.red}, ${toRgb.green}, ${toRgb.blue}, 0.4),
                        rgba(${toRgb.red}, ${toRgb.green}, ${toRgb.blue}, 0)
                        10%
                    )
                `;
            }

        case TEMPLATE_TYPES.topMiddle:
            if (displayOptions.gradientDirection === GRADIENT_DIRECTIONS.vertical) {
                return 'linear-gradient(to bottom, ' + displayOptions.gradientFrom + ', ' + displayOptions.gradientTo + ' 70%, rgba(' + toRgb.red + ', ' + toRgb.green + ', ' + toRgb.blue + ', 0) 100% )';
            } else {
                return `
                    radial-gradient(
                        ellipse at 10% 0%,
                        rgba(${fromRgb.red}, ${fromRgb.green}, ${fromRgb.blue}, 0.4),
                        rgba(${fromRgb.red}, ${fromRgb.green}, ${fromRgb.blue}, 0)
                        10%
                    ),
                    radial-gradient(
                        ellipse at 20% 0%,
                        rgba(${fromRgb.red}, ${fromRgb.green}, ${fromRgb.blue}, 0.7),
                        rgba(${fromRgb.red}, ${fromRgb.green}, ${fromRgb.blue}, 0)
                        30%
                    ),
                    radial-gradient(
                        ellipse at 40% 0%,
                        rgba(${fromRgb.red}, ${fromRgb.green}, ${fromRgb.blue}, 1),
                        rgba(${fromRgb.red}, ${fromRgb.green}, ${fromRgb.blue}, 0)
                        40%
                    ),
                    radial-gradient(
                        ellipse at 60% 0%,
                        rgba(${toRgb.red}, ${toRgb.green}, ${toRgb.blue}, 1),
                        rgba(${toRgb.red}, ${toRgb.green}, ${toRgb.blue}, 0)
                        40%
                    ),
                    radial-gradient(
                        ellipse at 80% 0%,
                        rgba(${toRgb.red}, ${toRgb.green}, ${toRgb.blue}, 0.7),
                        rgba(${toRgb.red}, ${toRgb.green}, ${toRgb.blue}, 0)
                        30%
                    ),
                    radial-gradient(
                        ellipse at 90% 0%,
                        rgba(${toRgb.red}, ${toRgb.green}, ${toRgb.blue}, 0.4),
                        rgba(${toRgb.red}, ${toRgb.green}, ${toRgb.blue}, 0)
                        10%
                    )
                `;
            }

        case TEMPLATE_TYPES.leftSide:
            if (displayOptions.gradientDirection === GRADIENT_DIRECTIONS.horizontal) {
                return 'linear-gradient(to right, ' + displayOptions.gradientFrom + ', ' + displayOptions.gradientTo + ' 70%, rgba(' + toRgb.red + ', ' + toRgb.green + ', ' + toRgb.blue + ', 0) 100% )';
            } else {
                return `
                    radial-gradient(
                        ellipse at 0% 10%,
                        rgba(${fromRgb.red}, ${fromRgb.green}, ${fromRgb.blue}, 0.4),
                        rgba(${fromRgb.red}, ${fromRgb.green}, ${fromRgb.blue}, 0)
                        10%
                    ),
                    radial-gradient(
                        ellipse at 0% 20%,
                        rgba(${fromRgb.red}, ${fromRgb.green}, ${fromRgb.blue}, 0.7),
                        rgba(${fromRgb.red}, ${fromRgb.green}, ${fromRgb.blue}, 0)
                        30%
                    ),
                    radial-gradient(
                        ellipse at 0% 40%,
                        rgba(${fromRgb.red}, ${fromRgb.green}, ${fromRgb.blue}, 1),
                        rgba(${fromRgb.red}, ${fromRgb.green}, ${fromRgb.blue}, 0)
                        40%
                    ),
                    radial-gradient(
                        ellipse at 0% 60%,
                        rgba(${toRgb.red}, ${toRgb.green}, ${toRgb.blue}, 1),
                        rgba(${toRgb.red}, ${toRgb.green}, ${toRgb.blue}, 0)
                        40%
                    ),
                    radial-gradient(
                        ellipse at 0% 80%,
                        rgba(${toRgb.red}, ${toRgb.green}, ${toRgb.blue}, 0.7),
                        rgba(${toRgb.red}, ${toRgb.green}, ${toRgb.blue}, 0)
                        30%
                    ),
                    radial-gradient(
                        ellipse at 0% 90%,
                        rgba(${toRgb.red}, ${toRgb.green}, ${toRgb.blue}, 0.4),
                        rgba(${toRgb.red}, ${toRgb.green}, ${toRgb.blue}, 0)
                        10%
                    )
                `;
            }

        case TEMPLATE_TYPES.rightSide:
            if (displayOptions.gradientDirection === GRADIENT_DIRECTIONS.horizontal) {
                return 'linear-gradient(to left, ' + displayOptions.gradientFrom + ', ' + displayOptions.gradientTo + ' 70%, rgba(' + toRgb.red + ', ' + toRgb.green + ', ' + toRgb.blue + ', 0) 100% )';
            } else {
                return `
                    radial-gradient(
                        ellipse at 100% 10%,
                        rgba(${fromRgb.red}, ${fromRgb.green}, ${fromRgb.blue}, 0.4),
                        rgba(${fromRgb.red}, ${fromRgb.green}, ${fromRgb.blue}, 0)
                        10%
                    ),
                    radial-gradient(
                        ellipse at 100% 20%,
                        rgba(${fromRgb.red}, ${fromRgb.green}, ${fromRgb.blue}, 0.7),
                        rgba(${fromRgb.red}, ${fromRgb.green}, ${fromRgb.blue}, 0)
                        30%
                    ),
                    radial-gradient(
                        ellipse at 100% 40%,
                        rgba(${fromRgb.red}, ${fromRgb.green}, ${fromRgb.blue}, 1),
                        rgba(${fromRgb.red}, ${fromRgb.green}, ${fromRgb.blue}, 0)
                        40%
                    ),
                    radial-gradient(
                        ellipse at 100% 60%,
                        rgba(${toRgb.red}, ${toRgb.green}, ${toRgb.blue}, 1),
                        rgba(${toRgb.red}, ${toRgb.green}, ${toRgb.blue}, 0)
                        40%
                    ),
                    radial-gradient(
                        ellipse at 100% 80%,
                        rgba(${toRgb.red}, ${toRgb.green}, ${toRgb.blue}, 0.7),
                        rgba(${toRgb.red}, ${toRgb.green}, ${toRgb.blue}, 0)
                        30%
                    ),
                    radial-gradient(
                        ellipse at 100% 90%,
                        rgba(${toRgb.red}, ${toRgb.green}, ${toRgb.blue}, 0.4),
                        rgba(${toRgb.red}, ${toRgb.green}, ${toRgb.blue}, 0)
                        10%
                    )
                `;
            }

        default: break;
    }
}

export const getTitlesContainerPositionStyle = (displayOptions, previewScale = 1) => {
    switch (displayOptions.displayType) {

        case TEMPLATE_TYPES.fullScreen:
            return {
                left: 960 * previewScale,
                top: 440 * previewScale,
                transform: `translate(-50%, -50%) scale(${previewScale})`,
            }

        case TEMPLATE_TYPES.bottomThird:
            return {
                left: 960 * previewScale,
                top: 870 * previewScale,
                transform: `translate(-50%, -50%) scale(${50 * previewScale}%)`,
            }

        case TEMPLATE_TYPES.bottomSixth:
            return {
                left: 960 * previewScale,
                top: 960 * previewScale,
                transform: `translate(-50%, -50%) scale(${30 * previewScale}%)`,
            }

        case TEMPLATE_TYPES.leftSide:
            return {
                left: 240 * previewScale,
                top: 540 * previewScale,
                transform: `translate(-50%, -50%) scale(${40 * previewScale}%)`,
            }

        case TEMPLATE_TYPES.rightSide:
            return {
                left: 1680 * previewScale,
                top: 540 * previewScale,
                transform: `translate(-50%, -50%) scale(${40 * previewScale}%)`,
            }

        case TEMPLATE_TYPES.topLeft:
            return {
                left: 320 * previewScale,
                top: 140 * previewScale,
                transform: `translate(-50%, -50%) scale(${50 * previewScale}%)`,
            }

        case TEMPLATE_TYPES.topRight:
            return {
                left: 1600 * previewScale,
                top: 140 * previewScale,
                transform: `translate(-50%, -50%) scale(${50 * previewScale}%)`,
            }

        case TEMPLATE_TYPES.topMiddle:
            return {
                left: 960 * previewScale,
                top: 140 * previewScale,
                transform: `translate(-50%, -50%) scale(${50 * previewScale}%)`,
            }

        default:
            return {
                left: 960 * previewScale,
                top: 540 * previewScale,
                transform: `translate(-50%, -50%) scale(${50 * previewScale}%)`,
            }
    }
}
